import React from 'react'

import Image from 'next/image'

import { PaddingProps } from 'styled-system'

import { SectionWrapper } from 'Components/Blocks'
import AddressRow from 'Components/Sections/MeetUsIn/AddressRow'
import { Column, Text } from 'Components/UI'

import { MapImage } from 'Assets/Image'

import { ADDRESS_ITEMS } from './constants'
import { Content, ImageHolder } from './styles'
import { AddressId } from './types'

type Props = PaddingProps

function MeetUsInSection({ ...rest }: Props) {
  return (
    <SectionWrapper {...rest}>
      <Content flexDirection={['column', 'column', 'column', 'column', 'row']}>
        <Column>
          <Text as="h2" mb={4} medium title title40>
            Meet Us In
          </Text>

          <Text
            body
            body16
            maxWidth={['unset', 'unset', 'unset', 'unset', '360px']}
            mb={11}
            semiLight
          >
            Our office is in Sydney. These are the cities our engineers work
            from, and where we meet clients in person.
          </Text>

          <Column gap={11}>
            {Object.values(ADDRESS_ITEMS)
              .filter(item => item.id !== AddressId.Headquarters)
              .map(item => (
                <AddressRow data={item} key={item.id} />
              ))}
          </Column>
        </Column>

        <Column
          fullHeight
          fullWidth
          justifyEnd
          maxWidth={['unset', 'unset', 'unset', 'unset', '60%']}
        >
          <Column fullWidth>
            <ImageHolder>
              <Image
                alt="World map of the locations where StartupCraft meets clients in person"
                src={MapImage}
              />
            </ImageHolder>

            <Text body20 mb={3} medium mt={6} title>
              {ADDRESS_ITEMS[AddressId.Headquarters].title}
            </Text>

            <Text body body16 semiLight>
              {ADDRESS_ITEMS[AddressId.Headquarters].caption}
            </Text>
          </Column>
        </Column>
      </Content>
    </SectionWrapper>
  )
}

export default MeetUsInSection
